import { Component } from '@angular/core';
import {
  MenuController,
  IonApp,
  IonMenu,
  IonContent,
  IonList,
  IonNote,
  IonMenuToggle,
  IonItem,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonButton,
  IonRouterLink,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonSearchbar,
  IonPopover
} from '@ionic/angular/standalone';

import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { addIcons } from 'ionicons';
import {
  home, water, hammer, flash, leaf, key,
  mailOutline, mailSharp, mail,
  paperPlaneOutline, paperPlaneSharp,
  heartOutline, heartSharp,
  archiveOutline, archiveSharp,
  trashOutline, trashSharp,
  warningOutline, warningSharp,
  bookmarkOutline, bookmarkSharp,
  colorPaletteOutline, colorPaletteSharp, colorPalette,
  gridOutline, construct, snow, albums,
  hardwareChip, business, person
} from 'ionicons/icons';
import { WhatsappFabComponent } from './components/whatsapp-fab/whatsapp-fab.component';



@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [
    IonApp,
    IonMenu,
    IonContent,
    IonList,
    IonNote,
    IonMenuToggle,
    IonItem,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonButton,
    IonRouterLink,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonMenuButton,
    IonSearchbar,
    IonPopover,
    RouterLink,
    RouterLinkActive,
    WhatsappFabComponent
  ]
})
export class AppComponent {
  public appPages = [
        { title: 'Inicio', url: '/folder/inicio', icon: 'home' },
    { title: 'Electricidad', url: '/folder/electricidad', icon: 'flash' },
    { title: 'Plomería', url: '/folder/plomeria', icon: 'water' },
    { title: 'Cancelería', url: '/folder/canceleria', icon: 'albums' },
    { title: 'Tablaroca', url: '/folder/tablaroca', icon: 'construct' },
    { title: 'Pintura', url: '/folder/pintura', icon: 'color-palette' },
    { title: 'Aire Acondicionado', url: '/folder/aire-acondicionado', icon: 'snow' },
    { title: 'Carpintería', url: '/folder/carpinteria', icon: 'hammer' },
    { title: 'Desazolve', url: '/folder/desazolve', icon: 'water' },
    { title: 'Herrería', url: '/folder/herreria', icon: 'hammer' },
    { title: 'Impermeabilización', url: '/folder/impermeabilizacion', icon: 'construct' },
    { title: 'Plantas de Emergencia', url: '/folder/plantas-de-emergencia', icon: 'leaf' },
    { title: 'Sistemas contra Incendio', url: '/folder/sistemas-contra-incendio', icon: 'warning-outline' },
    { title: 'Albañilería', url: '/folder/albanileria', icon: 'construct' },
    { title: 'Subestación Eléctrica', url: '/folder/subestacion-electrica', icon: 'flash' },
    { title: 'Plantas de Emergencia', url: '/folder/varios', icon: 'leaf' },
    { title: 'Contacto', url: '/folder/contacto', icon: 'mail' }
  ];

  constructor(private menu: MenuController, private router: Router) {
    addIcons({
      home, water, hammer, flash, leaf, key,
      mailOutline, mailSharp, mail,
      paperPlaneOutline, paperPlaneSharp,
      heartOutline, heartSharp,
      archiveOutline, archiveSharp,
      trashOutline, trashSharp,
      warningOutline, warningSharp,
      bookmarkOutline, bookmarkSharp,
      colorPaletteOutline, colorPaletteSharp, colorPalette,
      gridOutline, construct, snow, albums,
      hardwareChip, business, person
    });
  }

  closeMenu() {
    this.menu.close().then(() => {
      console.log('Menú cerrado');
    }).catch(err => {
      console.error('Error al cerrar el menú:', err);
    });
  }

  goToInicio() {
    this.router.navigate(['/folder/inicio']);
  }

  async toggleMenu() {
    await this.menu.toggle();
  }

  setLang(lang: 'es' | 'en') {
    // TODO: integrar i18n; por ahora solo log
    console.log('Idioma seleccionado:', lang);
  }
  // ===== Hover / Click controlled popovers for top navbar =====
  isPropsOpen = false;
  isServOpen = false;
  propsEvent: any;
  servEvent: any;
  private hoverCloseTimers: Record<string, any> = {};

  openHover(which: 'props' | 'serv', ev: Event) {
    this.cancelClose(which);
    if (which === 'props') {
      this.propsEvent = ev;
      this.isPropsOpen = true;
    } else {
      this.servEvent = ev;
      this.isServOpen = true;
    }
  }

  scheduleClose(which: 'props' | 'serv') {
    this.cancelClose(which);
    this.hoverCloseTimers[which] = setTimeout(() => {
      if (which === 'props') this.isPropsOpen = false;
      else this.isServOpen = false;
    }, 140);
  }

  cancelClose(which: 'props' | 'serv') {
    const t = this.hoverCloseTimers[which];
    if (t) { clearTimeout(t); delete this.hoverCloseTimers[which]; }
  }

  forceClose(which: 'props' | 'serv') {
    if (which === 'props') this.isPropsOpen = false;
    else this.isServOpen = false;
  }
}
